import React from 'react';
import { Alert, Button, Modal, Spinner } from 'react-bootstrap';

const InviteUserModal = (props) => {
  const { inviteUser, orgList, handleClose, handleInvite, inviteLoading, inviteError } = props;

  const selectedOrgNames =
    orgList
      ?.filter((o) => inviteUser?.organization?.includes(o.id))
      ?.map((o) => o.name) || [];

  let organizationPhrase = ' your organization?';
  if (selectedOrgNames.length === 1) {
    organizationPhrase = ' the following organization:';
  } else if (selectedOrgNames.length > 1) {
    organizationPhrase = ' the following organizations:';
  }

  return (
    <Modal show={inviteUser !== null} onHide={handleClose}>
      <Modal.Dialog>
        <Modal.Header closeButton>
          <Modal.Title>Invite Existing User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            A user with the email <strong>{inviteUser?.email}</strong> already exists in another
            organization. Do you want to invite them to{organizationPhrase}
          </p>
          {selectedOrgNames.length > 0 && (
            <ul>
              {selectedOrgNames.map((name) => (
                <li key={name}>{name}</li>
              ))}
            </ul>
          )}
          {inviteError && <Alert variant="danger">{inviteError}</Alert>}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            className="btn btn-custom white mr-3"
            onClick={handleClose}
            disabled={inviteLoading}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            className="btn btn-custom dark"
            onClick={handleInvite}
            disabled={inviteLoading}
          >
            {inviteLoading ? <Spinner animation="border" size="sm" /> : 'Invite'}
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </Modal>
  );
};

export default InviteUserModal;
